import axios from "axios";
import { standaloneLoader } from "../Components/Loader/StandAlondeLoader";


let axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL+"qix-deploy/api/",
  timeout: 90000,
});

axiosInstance.interceptors.request.use((config:any) => {
    const token = localStorage.getItem("authToken");
    config.headers = {
      Authorization: token,
    };
  standaloneLoader.showLoader()
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    standaloneLoader.hideLoader()
    return response;
  },
  async function (error) {
     if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.clear();
      window.location.href = "/login";
      
      return new Promise(() => {});
    }
    standaloneLoader.hideLoader()
    return Promise.reject(error);
  }
);

export default axiosInstance;